module.exports = __webpack_public_path__ + "static/img/applet.d83b37c1.png";